import { decode, encode } from 'base64-arraybuffer';
import CryptoJS from 'crypto-js';
import objectHash from 'object-hash';
import { DragEvent } from 'react';

export const isDroppable = (
  event: DragEvent<HTMLDivElement>,
  draggableEvent: string
): boolean => event.dataTransfer.types[0]?.split('/')[0] === draggableEvent;

export const setStyles = (
  node: HTMLElement,
  styles: Record<string, string>
): void => {
  Object.keys(styles).forEach((key: any) => {
    node.style[key] = styles[key];
  });
};

export const isDevEnv = (): boolean => process.env.NODE_ENV === 'development';

export { encode as convertArrayBufferToBase64 };

const convertBase64ToString = (value: string) => {
  const buffer = decode(value);
  return new TextDecoder().decode(buffer);
};

export const convertBase64toJSON = <T extends object>(
  value: string
): T | undefined => {
  try {
    return JSON.parse(convertBase64ToString(value));
  } catch {
    return undefined;
  }
};

export const convertStringToBase64 = (value: string): string => {
  const utf8Bytes = new TextEncoder().encode(value);
  return encode(utf8Bytes);
};

export const convertJSONtoBase64 = <T extends object>(value: T): string => {
  return convertStringToBase64(JSON.stringify(value));
};
export const getFingerprintHash = (): string => {
  function getGPUInfo() {
    const canvas = document.createElement('canvas');
    const gl = (canvas.getContext('webgl') ||
      canvas.getContext('experimental-webgl')) as WebGLRenderingContext;
    if (!gl) return 'Unknown';
    const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
    return debugInfo
      ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
      : 'Unknown';
  }
  const fingerprint = {
    userAgent: navigator.userAgent, // Browser & OS info
    language: navigator.language, // User language
    screenSize: `${screen.width}x${screen.height}`, // Screen resolution
    colorDepth: screen.colorDepth, // Color depth
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, // Timezone
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    platform: navigator.platform, // OS Platform
    cpuCores: navigator.hardwareConcurrency || 'Unknown', // CPU cores
    // @ts-expect-error RAM is not always available)
    memory: navigator.deviceMemory || 'Unknown', // RAM
    touchSupport: 'ontouchstart' in window, // Touchscreen or not
    gpu: getGPUInfo(), // GPU details (WebGL)
  };
  return objectHash(JSON.stringify(fingerprint));
};

export const encryptWithFingerprint = (value: string): string => {
  return CryptoJS.AES.encrypt(value, getFingerprintHash()).toString();
};

export const decryptWithFingerprint = (value: string): string => {
  return CryptoJS.AES.decrypt(value, getFingerprintHash()).toString(
    CryptoJS.enc.Utf8
  );
};

export function readAsUint8Array(file?: Blob): Promise<Uint8Array> {
  const reader = new FileReader();
  if (file) reader.readAsArrayBuffer(file);

  return new Promise((resolve, reject) => {
    reader.onloadend = ({ target }) =>
      resolve(new Uint8Array((target as any).result as ArrayBuffer));
    reader.onerror = reject;
  });
}
